import NavBar from "./NavBar"


const Header = () => {
  return <header>
    <NavBar />
  </header>
}

export default Header